export enum AdSource {
  Microsoft = 'Microsoft',
  Auction = 'Auction',
  XandrAuction = 'Xandr Auction',
}
